import type { ProductSetupConfig, SetupTaskGroup } from "../../registry/types";
import { SHOPPER_AGENT_INTAKE_QUESTIONS } from "./intake";

const GROUPS: SetupTaskGroup[] = [];

export const shopperAgentProductConfig: ProductSetupConfig = {
  product: "shopperAgent",
  displayName: "Concierge",
  routePattern: /\/redo-concierge(\/|$)/,
  resumeRoute: (storeId) => `/stores/${storeId}/redo-concierge`,
  // No `onIntakeSubmit` yet — Concierge has no post-intake activation
  // step today. Intake just persists answers; the welcome overlay does
  // not fire (matches existing host behavior pre-refactor).
  intake: {
    questions: SHOPPER_AGENT_INTAKE_QUESTIONS,
    welcome: {
      title: "Welcome to Concierge",
      subtitle: "Let's get your new Concierge experience scaffolded.",
    },
    dismissible: true,
  },
  groups: GROUPS,
  tasks: {},
  completion: {
    title: "Concierge is ready",
    body: "Your Concierge scaffold is set up. Next we'll finish the onboarding details and connect it to the playbook.",
    ctaText: "Got it",
  },
  // Keep the memo key scoped to the settings subtree this product will own.
  relevantTeamSlice: (team) => team.settings?.shopperAgent,
};
